import { FC, ReactNode, useState, useRef } from 'react';

interface NavItemTooltipProps {
  content: string;
  children: ReactNode;
  hidden?: boolean;
  offset?: [number, number];
}

const NavItemTooltip: FC<NavItemTooltipProps> = ({
  content,
  children,
  hidden = false,
  offset = [10, 0],
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = (e: React.MouseEvent) => {
    if (wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setPosition({
        x: rect.right + offset[0],
        y: rect.top + rect.height / 2 + offset[1],
      });
      setIsVisible(true);
    }
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  return (
    <div
      ref={wrapperRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className='relative'
    >
      {children}
      {isVisible && !hidden && (
        <div
          data-testid='nav-item-tooltip'
          className='fixed z-50 px-2 py-1 text-sm text-off-white bg-primary-darker rounded shadow-lg pointer-events-none whitespace-nowrap'
          style={{
            left: `${position.x}px`,
            top: `${position.y}px`,
            transform: 'translateY(-50%)',
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default NavItemTooltip;
